import type { IStorageAdapter } from "@frontend-shared/utils";

// NOTE: NSAI-1249 — the browser's localStorage behind the shared adapter
// interface. Extracted from `api/services.ts` so the feature-flag store can
// reach the same storage the API client uses instead of the two growing their
// own copies; mobile's counterpart is `mobile/src/utils/storage.ts`.
export const localStorageAdapter: IStorageAdapter = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
};
